<c-card *transloco="let t">
  <c-card-body class="px-2" *transloco="let t">

          <c-row>
            <c-col md="12" lg="6">
                <h1>{{ t('Timed Activities') }}</h1>
            </c-col>
            <c-col md="12" lg="6">
            <c-row class="justify-content-end">
              <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
                <c-input-group  class="text-end">
                  <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                  <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                    <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                  </select>
                </c-input-group>
              </c-col>
              <c-col xs="auto" class="mb-2">
                <!-- <c-input-group>
                  <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                  <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                    <option value="newest">{{ t('Newest') }}</option>
                    <option value="oldest">{{ t('Oldest') }}</option>
                    <option value="name">{{ t('Name') }}</option>
                  </select>
                </c-input-group> -->
              </c-col>
              <c-col xs="auto" class="mb-2">
                <button type="button" class="btn btn-light mb-2 me-1" aria-expanded="false" (click)="getActivities()">
                  <i class="fa-solid fa-arrows-rotate"></i> {{ t('Refresh') }}
                </button>
                <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
                  <i class="fa-solid fa-file-excel"></i> {{ t('Export Activities') }}
                </button>
              </c-col>
            </c-row>
          </c-col>


          </c-row>
          <c-row>
            <c-col md="12" lg="12">

          <c-card class="mb-2">
            <c-card-body>


              <form cForm class="row row-cols-lg-auto g-3 align-items-center" (ngSubmit)="getActivities()">

                <c-col xs="auto">
                  <label cLabel class="visually-hidden" for="search">
                    {{ t('Search') }}
                  </label>
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                    <input cFormControl [(ngModel)]="search" id="search" name="search" placeholder="{{ t('Search') }}" />
                  </c-input-group>
                </c-col>

                <c-col xs="auto">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                    <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>

                  </c-input-group>

                </c-col>
                
                <c-col xs="auto">
                  <ng-select
                    [items]="okService.workers"
                    placeholder="{{ t('Worker') }}"
                    bindLabel="name"
                    bindValue="id"
                    [(ngModel)]="worker_id"
                    name="worker_id"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="auto" *ngIf="okService.groups && okService.groups.length > 0 && okService.hasFeature('groups')">
                  <ng-select
                  [items]="okService.groups"
                  [(ngModel)]="group"
                  bindLabel="name"
                  bindValue="id"
                  name="group"
                  placeholder="{{ t('Worker Group') }}"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="auto">
                  <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Search') }}</button>
                  &nbsp;
                  <button cButton class="btn btn-light text-danger" type="submit"  (click)="clearFilter()" *ngIf="hasFilter()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </c-col>

                </form>

            </c-card-body>
          </c-card>
        </c-col>

      </c-row>

          <c-row *ngIf="activities">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ t('Status') }}</th>
                    <th scope="col">{{ t('Activity') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Time') }}</th>
                    <th scope="col">{{ t('Actions') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    @for(activity of activities; track activity){

                      <tr>
                        <td>
                          <i class="fa-solid fa-circle-check fa-3x text-success" *ngIf="activity.completed"></i>
                          <i class="fa-solid fa-triangle-exclamation fa-3x text-warning" *ngIf="activity.overdue && !activity.completed"></i>
                          <i class="fa-solid fa-hourglass-half fa-3x text-info" *ngIf="activity.active && !activity.completed"></i>
                        </td>
                        <td>
                          <span class="fs-5">{{activity.name}}</span>
                        </td>
                        <td>
                          <span class="fs-5"><span *ngIf="activity.worker">{{activity.worker.name}}</span></span>
                        </td>
                        <td>
                          <span class="fs-7"><b>{{ t('Start Time:')}}</b>&nbsp;{{activity.start_at_local}}</span>
                          <br/>
                          <span class="fs-7"><b>{{ t('End Time:')}}</b>&nbsp;{{activity.end_at_local}}</span>
                          @if(activity.completed_at_local){
                          <br/>
                          <span class="fs-7"><b>{{ t('Completed Time:')}}</b>&nbsp;{{activity.completed_at_local}}</span>
                          }
                        </td>
                        <td>
                          <span *ngFor="let action of activity.actions" [innerHTML]="action.html"></span>
                        </td>

                      </tr>
                    }
                  </tbody>

              </table>

            </c-col>
          </c-row>

  </c-card-body>
</c-card>
